import React from "react";
import { FaChartLine, FaCoins, FaLaptopCode, FaProjectDiagram, FaServer } from "react-icons/fa";

// Decorative — the adjacent service title always conveys the meaning, so hide the
// glyphs from assistive tech (matches the Contact/Footer/Booking icon convention).
export const serviceIcons = {
  aiAutomation: <FaProjectDiagram aria-hidden="true" />,
  powerBiAnalytics: <FaChartLine aria-hidden="true" />,
  dataPlatform: <FaServer aria-hidden="true" />,
  internalTools: <FaLaptopCode aria-hidden="true" />,
  financialServices: <FaCoins aria-hidden="true" />,
};
